<template>
    <div>
        <v-autocomplete class="pt-4"
                v-model="id"
                :items="clients"
                label="Client"
                item-text="company_name"
                item-value="id"
                color="secondary"
        >
        </v-autocomplete>
    </div>
</template>

<script>
    export default {
        data : function() {
            return {
                id: null,
                clients: null
            }
        },
        created () {
            this.getClients();
            this.getActiveClient();
        },
        watch: {
            id: function (newValue, oldValue) {
                var red = false;
                if (oldValue != null) {
                    red = true;
                }
                this.updateClienteActivo(red);
            },
        },
        methods: {
            getClients () {
                this.$store.dispatch('getSelectClientsAgent').then((res) => {
                    this.clients = res.data;
                }).catch((error) => {

                });
            },
            updateClienteActivo (red) {
                this.$store.dispatch('updateClienteActivo', {
                    cliente_id: this.id
                }).then((res) => {
                    if (red) {
                        this.$router.push('/a');
                    }
                    cliente_id = this.data.cliente_id;

                }).catch((error) => {

                });
            },
            getActiveClient() {
                this.$store.dispatch('getActiveClient').then((res) => {
                    this.id = res.data.id;
                }).catch((error) => {

                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/ChangeUser.vue